<script> 
  export default {
    name: 'FormElement'
  }
</script>

<template>
  <div class="FormElement">
    <slot></slot>
  </div>
</template>
